import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Switch } from '../shapes';


const SwitchSvg = (props) => (
  <g>
    <IconBounds />
    <Switch {...props} />
  </g>
);

SwitchSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

SwitchSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default SwitchSvg;
